import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import * as DatiFide from "src/DatiFide";
import { Trad } from "src/components";
import { _AddClientButton } from "../../components";
import { _Autocomplete, _DateField, _NumberField, _Select } from "../../form";

const useStyles = makeStyles(({ palette }: Theme) => ({
    deleteIcon: {
        color: palette.error.main
    },
    cell: {
        borderBottom: "none"
    },
    detailsCell: {
        width: "40%"
    }
}));

interface ICoobligatedListProps {
    Data: DatiFide.CRisAPILista_FideCoobbligato;
    OnChange: (e: React.FormEvent<any> | string, val?: unknown) => void;
}

export const _CoobligatedList: React.FC<ICoobligatedListProps> = ({ Data, OnChange }) => {
    const classes = useStyles();

    const onChangeAmount = (val: string, index: number) => {
        if (Data.Extra.Importo) {
            OnChange(`RisAPI.Dati.${index}.Quota`, (Number(val) / Data.Extra.Importo) * 100);
        }
    };

    const onDeleteCoobliged = (index: number) => {
        const items = [...Data.RisAPI.Dati];

        items.splice(index, 1);
        OnChange("RisAPI.Dati", items);
    };

    const onAddClient = (value: string, index: number) => {
        OnChange(`RisAPI.Dati.${index}.ID_Anag`, value);
    };

    return (
        <Table aria-label="coobligated list" size="small">
            <TableHead>
                <TableRow>
                    <TableCell align="center">{Trad.Trad("Coobbligati")}</TableCell>
                    <TableCell align="center">{Trad.Trad("Quota")}</TableCell>
                    <TableCell align="center">{Trad.Trad("Importo")}</TableCell>
                    <TableCell align="center">{Trad.Trad("Azioni")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {Data.RisAPI.Dati.map((item, index) => (
                    <TableRow key={index} hover>
                        <TableCell className={`${classes.cell} ${classes.detailsCell}`}>
                            <_AddClientButton OnAddClient={(val: string) => onAddClient(val, index)}>
                                <_Autocomplete Value={item.ID_Anag ?? "0"} Name={`RisAPI.Dati.${index}.ID_Anag`} Label="" OnChange={OnChange} Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" />
                            </_AddClientButton>
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <_NumberField Id={`RisAPI.Dati.${index}.Quota`} Label="" Value={item.Quota} Adornment="%" OnChange={OnChange} />
                        </TableCell>
                        <TableCell className={classes.cell}>
                            <_NumberField Id={`${index}_Importo`} Label="" Value={(item.Quota * Data.Extra.Importo) / 100} OnChange={(e, val) => onChangeAmount(val, index)} />
                        </TableCell>
                        <TableCell align="center" className={classes.cell}>
                            <Tooltip title={Trad.Trad("Elimina")}>
                                <IconButton aria-label="delete" size="small" className={classes.deleteIcon} onClick={() => onDeleteCoobliged(index)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsCoobligated/CoobligatedList.tsx